import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";
import dataService from "../../api";

const state = {
    users: [],
    features: [],
    employees: [],
    doctors: [],
    user: {
        permissions:[]
    },
    totalItems:0,

};

const getters = {
    index: state => userId => state.users.findIndex(i => i.id === userId)
};

const mutations = {
    setUsers: (state, r) => (state.users = r),
    setEmployees: (state, r) => (state.employees = r),
    setDoctors: (state, r) => (state.doctors = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    setUser: (state, r) => (state.user = r),
    setFeatures: (state, r) => (state.features = r),
    add: (state, r) => state.users.unshift(r),
    delete: (state, index) => state.users.splice(index, 1),
    lock: (state, index) => state.users[index].status = status.locked,
    unlock: (state, index) => state.users[index].status = status.active,
    edit: (state, { index, r }) => state.users.splice(index, 1, r),

};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.users.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setUsers", response.data.users);
            commit("setTotalItems", response.data.totalItems);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
     async getEmployees({ commit }) {
        try {
       
            startLoading()
            const response = await dataService.users.getEmployees();

            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            // commit("setUsers", response.data.users);
            commit("setEmployees", response.data.employees);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },  
       async getDoctors({ commit }) {
        try {
       
            startLoading()
            const response = await dataService.users.getDoctors();

            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setDoctors", response.data.doctors);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.users.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.user);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.users.delete(id);

            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async lock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.users.lock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("lock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async unlock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.users.unlock(id);

            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("unlock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setUser", {
                permissions:[]
            });
            startLoading()
            const response = await dataService.users.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
            commit("setUser", response.data.user);
        
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.users.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.user);
        
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.users.edit(id,payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
            showNotification(response.data.message);

            const index = getters.index(id);
            commit("edit", { index, r: response.data.user });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async resetPassword(_, id) {
        try {
            startLoading()
            const response = await dataService.users.resetPassword(id);

            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            showAlert(" كلمة المرور الجديدة:" + "[   " + response.data.password + "   ]");
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getFeatures({ commit },typeId) {
        try {
            commit("setFeatures", {});

            startLoading()
            const response = await dataService.users.getFeatures(typeId);

            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setFeatures", response.data.features);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
